import { bl_crm_member_label_topic_link_RowClass } from '../../../dbschema/bl_crm_member_label_topic_link.model';
import {BaseContainerModel} from '../../base-container.model';

export class MemberLabelTopicLinkContainerModel extends BaseContainerModel {
  bl_crm_member_label_topic_link: bl_crm_member_label_topic_link_RowClass = new bl_crm_member_label_topic_link_RowClass();
}
